import { FC, memo } from 'react';
import './style.scss';
import { REFUND_LOG_COLUMN } from '../../constants/refundLogRow';
import { getCellText, getAmount, getRefundTypeTxt } from '../../helpers/RefundLog';
import { getBusinessDateFormat } from '~/helpers';
import { IProps } from '~/view/screens/RefundLogScreen/screens/RefundLog/types/refundLog';
import { Icons } from '~/assets/fonts/Icons/icons';
import theme from '~/constants/styles';
import Icon from '~/view/components/Controls/Icon/Icon';
import CustomTooltip from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import { TransactionStatus } from '~/view/components/Transaction/TransactionStatus';
import { TRANSACTION_STATUSES } from '~/types/orders';

const RefundLogListRow: FC<IProps> = ({ refundLog }: IProps): JSX.Element | null => {
  if (!refundLog) {
    return null;
  }

  const defaultClassesWithoutElipsis = 'family-medium text-size-16';
  const defaultClassesWithElipsis = 'family-medium text-size-16 text-elipsis';
  const defaultClassesWithBreakWord = 'family-medium text-size-16 break-word';

  const date = getBusinessDateFormat(refundLog.transaction_at);
  const author = getCellText(refundLog.author_name);
  const branch = getCellText(refundLog.branch_name);
  const order_id = getCellText(refundLog.order_reference);
  const amount = getAmount(refundLog.transaction_amount, refundLog.transaction_currency);
  const type = getRefundTypeTxt(refundLog.transaction_type);
  const reason = getCellText(refundLog.transaction_reason);
  const arn = getCellText(refundLog.transaction_arn);
  const branch_is_deleted = refundLog.branch_is_deleted;
  const transaction_status = refundLog.transaction_status ?? TRANSACTION_STATUSES.UNKNOWN;

  const renderDeleteBranch = (branch_is_deleted: number): JSX.Element | null => {
    return branch_is_deleted ? (
      <CustomTooltip message="branch_was_deleted">
        <Icon name={Icons.Warning} size={15} color={theme.colors.red} />
      </CustomTooltip>
    ) : null;
  };

  return (
    <div className="refund-log-list">
      <div className={`cell cell-${REFUND_LOG_COLUMN.DATE}`}>
        <p className={defaultClassesWithElipsis}>{date}</p>
      </div>

      <div className={`cell cell-${REFUND_LOG_COLUMN.AUTHOR}`}>
        <p className={defaultClassesWithElipsis}>{author}</p>
      </div>

      <div className={`cell cell-${REFUND_LOG_COLUMN.BRANCH}`}>
        <p className={defaultClassesWithElipsis}>{branch}</p>
        {renderDeleteBranch(branch_is_deleted)}
      </div>

      <div className={`cell cell-${REFUND_LOG_COLUMN.ORDER_ID}`}>
        <p className={defaultClassesWithoutElipsis}>{order_id}</p>
      </div>

      <div className={`cell cell-${REFUND_LOG_COLUMN.AMOUNT}`}>
        <p className={defaultClassesWithElipsis}>{amount}</p>
      </div>

      <div className={`cell cell-${REFUND_LOG_COLUMN.STATUS}`}>
        <TransactionStatus status={transaction_status} />
      </div>

      <div className={`cell cell-${REFUND_LOG_COLUMN.TYPE}`}>
        <p className={defaultClassesWithElipsis}>{type}</p>
      </div>

      <div className={`cell cell-${REFUND_LOG_COLUMN.REASON}`}>
        <p className={defaultClassesWithElipsis}>{reason}</p>
      </div>

      <div className={`cell cell-${REFUND_LOG_COLUMN.ARN}`}>
        <p className={defaultClassesWithBreakWord}>{arn}</p>
      </div>
    </div>
  );
};

export default memo(RefundLogListRow);
